<template>
    <Transition name="fade-out">
        <AlertMessage
            v-if="visible"
            type="success"
            :show-icon="true"
            :dismissable="true"
            >{{ $tm('general.savedchanges') }}</AlertMessage
        >
    </Transition>
</template>
<script lang="ts" setup>
import { AlertMessage } from '@/components';
import { $tm } from '@/locize';

withDefaults(
    defineProps<{
        /**
         * Whether the message is visible or not
         * @default true
         */
        visible?: boolean;
    }>(),
    {
        visible: true,
    },
);
</script>
